module.exports = __webpack_public_path__ + "static/a_doors-15fc8c480b14b8f59c0bf99b2718630a.jpg";